import { TrayState } from "./TrayState";

export type ZoneType = "residential" | "commercial" | "industrial" | "roads";

export class GridTile extends Phaser.GameObjects.Zone {
    id: number;
    type: ZoneType;

    row: number;
    col: number;

    COMMERCIAL_CUTOFF = 400;
    RESIDENTIAL_CUTOFF = 900;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number, id: number) {
        super(scene, x, y, width, height);

        this.id = id;

        var color;

        if (this.x < this.COMMERCIAL_CUTOFF) {
            this.type = "commercial";
            color = TrayState.COMMERCIAL.color;
          
        }
        else if (this.x > this.COMMERCIAL_CUTOFF && this.x < this.RESIDENTIAL_CUTOFF) {
            this.type = "residential";
            color = TrayState.RESIDENTIAL.color;
        }
        else {
            this.type = "industrial";
            color = TrayState.INDUSTRIAL.color;
        }

        this.setRectangleDropZone(this.width, this.height);

        this.scene.add.existing(this);
    }
}

export class MoveableCityTile extends Phaser.GameObjects.Sprite {
    id: number;
    type: ZoneType;
    placed: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number, texture: string, id: number, type: ZoneType) {
        var f = type === "roads" ? "road" : type === "commercial" ? "comm" : type === "industrial" ? "ind" : type === "residential" ? "res" : null;
        super(scene, x, y, texture, f + id);
        this.id = id;
        this.type = type;
        this.placed = false;

        this.setOrigin(0, 1);
        this.setDepth(5);

        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);
    }
}

export class StaticCityTile extends Phaser.GameObjects.Sprite {
    id: number;
    type: ZoneType;
    placed: boolean;
    outline: Phaser.GameObjects.Sprite;

    constructor(scene: Phaser.Scene, x: number, y: number, texture: string, id: number, type: ZoneType) {
        var f = type === "roads" ? "road" : type === "commercial" ? "comm" : type === "industrial" ? "ind" : type === "residential" ? "res" : null;
        super(scene, x, y, texture, f + id);
        this.id = id;
        this.type = type;
        this.placed = false;

        var size = (this.width === 200 && this.height === 200) ? "L" : (this.width === 100 && this.height === 200) ? "S" : "";

        this.outline = this.scene.add.sprite(this.x - 2.5, this.y - 2.5, "assets", f + size);
        this.outline.setDisplaySize(this.width + 5, this.height + 5);
        this.outline.setVisible(false);
        Phaser.Display.Align.In.Center(this.outline, this);

        this.setOrigin(0, 1);
        this.setDepth(1);

        this.scene.add.existing(this);
    }

    updateOutline() {
        this.outline.setVisible(true);
        Phaser.Display.Align.In.Center(this.outline, this);
    }

    visibility(visible: boolean) {
        this.setVisible(visible);
        this.outline.setVisible(visible);
    }

}



// WEBPACK FOOTER //
// ./src/games/CityBuilderGame/objects/GridTile.ts